import { render, staticRenderFns } from "./view.vue?vue&type=template&id=9ae83b1c&scoped=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"
import style0 from "./view.vue?vue&type=style&index=0&id=9ae83b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae83b1c",
  null
  
)

export default component.exports